// src/i18n/data.ts

// Import the enhanced data manager and its types
import { 
  enhancedDataManager,
  TransportMode,
  Material,
  TransportUnit,
  HalatType as HalatVariant
} from '../utils/enhanced-data-manager';

// Re-export types for backward compatibility
export type { 
  TransportMode, 
  Material, 
  TransportUnit, 
  HalatVariant 
};

// Export the enhanced data manager as dataManager for backward compatibility
export const dataManager = {
  load: async (): Promise<void> => {
    try {
      await enhancedDataManager.load();
    } catch (error) {
      const { dataLogger } = await import('../utils/logger');
      dataLogger.error('Failed to load data', error as Error);
      throw error;
    }
  },
  
  getTransportModes: (): TransportMode[] => {
    if (!enhancedDataManager.isLoaded()) {
      throw new Error('Data not loaded. Call load() first.');
    }
    return enhancedDataManager.getTransportModes();
  },
  
  getMaterials: (): Material[] => {
    if (!enhancedDataManager.isLoaded()) {
      throw new Error('Data not loaded. Call load() first.');
    }
    return enhancedDataManager.getMaterials();
  },
  
  getTransportUnits: (): TransportUnit[] => {
    if (!enhancedDataManager.isLoaded()) {
      throw new Error('Data not loaded. Call load() first.');
    }
    return enhancedDataManager.getTransportUnits();
  },
  
  getHalatTypes: (): HalatVariant[] => {
    if (!enhancedDataManager.isLoaded()) {
      throw new Error('Data not loaded. Call load() first.');
    }
    return enhancedDataManager.getHalatTypes() as HalatVariant[];
  },
  
  getVersion: (): string => {
    return enhancedDataManager.getVersion();
  },
  
  isLoaded: (): boolean => {
    return enhancedDataManager.isLoaded();
  }
};